import { Component, OnInit, AfterViewInit } from '@angular/core';
import { UnedaService } from '../../services/uneda.service';
import { UserService } from '../../services/user.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Methods } from '../../shared/methods';

declare interface DataTable {
  headerRow: string[];
  footerRow: string[];
  dataRows: string[][];
}

declare const $: any;

@Component({
  selector: 'app-listunedainventory',
  templateUrl: './listunedainventory.component.html',
  styleUrls: ['./listunedainventory.component.css'],
  providers: [ UnedaService ]
})
export class ListunedainventoryComponent implements OnInit, AfterViewInit {
  public mtds: Methods = new Methods();
  public data: DataTable;
  public identity;
  public token;
  public privilegio;
  public loading: boolean = false;

  public idCompany;
  public companyFather;
  public unedaType;

  constructor(private _unedaService: UnedaService,
     private _router: Router,
    private _userService: UserService) {


    this.privilegio = JSON.parse(localStorage.getItem("privilegio"));
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();

    this.getUser();
    this.loading = true;
    this._unedaService.getAll().subscribe(
      response => {

        if (response.status === 'success') {
          console.log(response);
          let rows = [];
          response.data.forEach(function(element) {
            let row = [
              element.id,
              element.name,
              element.qty
            ];

            rows.push(row);
          }.bind(this));
          this.loading = false;

          this.data = {
            headerRow: ['id', 'Name', 'Qty'],
            footerRow: ['id', 'Name', 'Qty'],
            dataRows: rows
          };

        } else {
          this.data = {
            headerRow: ['id', 'Name', 'Qty'],
            footerRow: ['id', 'Name', 'Qty'],
            dataRows: []
          };
          this.mtds.notifyError(response.msg, response.code);
        }
      }, error => {
        this.data = {
          headerRow: ['id', 'Name', 'Qty'],
          footerRow: ['id', 'Name', 'Qty'],
          dataRows: []
        };
        this.mtds.notifyError(error.statusText, error.status);
      }
    );

  }

  getUser(){

    this.loading = true;
   
   

   this._userService.getUser(this.token, this.identity.sub).subscribe(
        response => {
          console.log('Usuario: ');
          console.log(response);

          if (response.status == 'success') {
            this.idCompany = response.data.companyLinked.id;
            this.companyFather = response.data.companyLinked;
            console.log(this.companyFather.unedaEnabled);
           
            this.unedaType = this.companyFather.unedaType;

            

             this.loading = false;
            
          } else {
            localStorage.clear();
            this._router.navigate(['/pages/lock']);
          }
        },
        error => {
          console.log(<any>error);
        }
      );

   
    
     
 
  }


  ngOnInit() {
  }

  ngAfterViewInit() {

    if(this.companyFather.unedaType == 'INVENTORY'){
        $('#datatable').DataTable({
      'order': [[ 0, 'desc' ]],
      dom: 'Bflrtip',
        buttons: [
          /*{
            extend: 'copy',
            exportOptions: {
              columns: ':visible'
            }
          },*//*
          {
            extend: 'csv',
            exportOptions: {
              columns: ':visible'
            }
          },*/
          {
            extend: 'excel',
            text: '<i class="fa fa-file-excel-o"></i>',
            titleAttr: 'Excel',
            className: 'btn btn-sm btn-outline-success',
            exportOptions: {
              columns: ':visible'
            }
          },
          {
            extend: 'pdf',
            text: '<i class="fa fa-file-pdf-o"></i>',
            titleAttr: 'PDF',
            className: 'btn btn-sm btn-outline-danger',
            exportOptions: {
              columns: ':visible'
            }
          },
          {
            extend: 'print',
            text: '<i class="fa fa-print" aria-hidden="true"></i>',
            titleAttr: 'print',
            className: 'btn btn-sm btn-outline-primary',
            exportOptions: {
              columns: ':visible'
            }
          },
          {
            extend: 'colvis',
            text: '<i class="fa fa-columns" aria-hidden="true"></i>',
            className: 'btn btn-sm btn-outline-info',
            titleAttr: 'Column visibility'
          },
        ],
      'pagingType': 'full_numbers',
      'lengthMenu': [
        [5, 10, 25, 50, 100, 200, 500, 1000, -1],
        [5, 10, 25, 50, 100, 200, 500, 1000, 'All']
      ],
      responsive: true,
      language: {
        search: '_INPUT_',
        searchPlaceholder: 'Search records',
      }

    });
    }
    

  }

}
